export default __webpack_public_path__ + "static/media/purple.a324a000.png";